import React from 'react';

import { Link } from '@insticator/insticator-ui'; // iui-material
//abbreviated months array util
import { abbreviatedMonths } from '@insticator/insticator-ui'; // iui-utils
//column head example {total: '', [`2019-01-01`]: 'Jan 1', [`2019-01-02`]: 'Jan 2', [`2019-01-03`]: 'Jan 3' }
//row of data example  { rank: '#1', topquestion: 'Which vitamin is essential for nervous system', answers: '3,765', embed: <Link type={`internal`} text={``} color={`primary`} action={`dashboard/`} icon={<Icon name={`external-link-alt`} />} />  }




export const transpileByDateTableColumnHead = (data) =>{
    //Message from Jon: Yes I know this is a lot. I will revisit when I have more time
    //I turn the columnhead object in to an array so that i can sort it based on date
    //then turn it back in to an object 😅 we rely on the order of the column head object
    //to determine the order of columnheads. relying on the order of object properties is not stable
    if(!Object.keys(data).length) return;
    let columnHead = { total: '' };
    Object.keys(data[Object.keys(data)[0]]['by_date']).forEach(item=>{
        let colDate = new Date(item.split('-').join("/"));
        columnHead[item] = `${abbreviatedMonths[colDate.getMonth()]} ${colDate.getDate()}`
    });

    let sortable = [];
    Object.keys(columnHead).forEach(item=>{
        sortable.push([item, columnHead[item]])
    });

    sortable.sort((a,b)=> new Date(a[0]).getTime() - new Date(b[0]).getTime());
    let newColumnHead = {};
    sortable.map(item=> newColumnHead[item[0]] = item[1] );
    return newColumnHead
};

export const transpileTableBody = (data, metricType)=>{
    let tableData = [];
    let tempObj = {};
    //I added this check on the aggregate property to ensure that we arent showing a table full of empty values
    //this is very specific to our current data structure but is the only way we can be sure
    if(!data || !data.total || !data.total.aggregate) return tableData;
    Object.keys(data).forEach(item=>{
        tempObj = Object.assign({}, data[item]['by_date']);
        tempObj.total = item === 'total' ? 'Total' : item;
        Object.keys(tempObj).forEach(date => tempObj[date] = tempObj[date] === null ? 'N/A' : formatCellData(tempObj[date], metricType));
        tableData.push(tempObj)
    });

    return tableData
};

//tableData helpers
//this will format each cells data appropriately have to check iNaN because addons and content metrics return different types
// Content: Number, Revenue: String
const formatCellData = (item, metricType) => {
    if(metricType === 'percent'){
        return isNaN(item) ? item : `${Number(item).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
    }else if(metricType === 'dollar'){
        return isNaN(item) ? item : Number(item).toLocaleString('en-US',{style: 'currency', currency: 'usd', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }else{
        return isNaN(item) ? item : Number(item).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2});
    }
};

//this might end up being a switch statement. idk
export const transpileByEmbedTableColumnHead = () => ({ rank: 'Rank', question: 'Top answered questions', answers: 'Answers', embed_uuid: 'Embed' });
export const transpileByStoryTableColumnHead = (detail) => ({ rank: 'Rank', title: detail ? 'Story' : 'Most clicked stories', clicks: 'Clicks', embed_uuid: 'Embed' });

//the links passed in to this table arent smart yet./

export const transpileByQuestionTableBody = (data, linkToEmbed, indexClicked) => {
    let tableData = [];
    let tempObj = {};
    if(!data.length) return tableData;
    Object.keys(data).forEach((item, index)=>{
        tempObj = Object.assign({}, data[item]);
        tempObj.answers = formatCellData(tempObj.answers);
        tempObj.handleRowClick = () => linkToEmbed(index, data[item].embed_uuid);
        tempObj.processing = indexClicked === index;
        tempObj.disabled = indexClicked !== null && indexClicked !== index;
        tempObj.embed_uuid = <Link
                                   type={`action`}
                                   text={``}
                                   color={`primary`}
                                   currentPage={'dashboard/home'}
                                   action={()=> linkToEmbed(index, data[item].embed_uuid)}
                                   icon={`external-link-alt`}
                                   disabled={indexClicked !== null && indexClicked !== index}
                                   operation={`load`}
                                   processing={indexClicked === index} />;
        tableData.push(tempObj)
    });

    return tableData
};

export const transpileByStoryTableBody = (data, linkToEmbed, indexClicked) => {
    let tableData = [];
    let tempObj = {};
    if(!data.length) return tableData;
    Object.keys(data).forEach((item, index)=>{
        tempObj = Object.assign({}, data[item]);
        tempObj.clicks = formatCellData(tempObj.clicks);
        tempObj.handleRowClick = () => linkToEmbed(index, data[item].embed_uuid);
        tempObj.processing = indexClicked === index;
        tempObj.disabled = indexClicked !== null && indexClicked !== index;
        tempObj.embed_uuid = <Link
                                   type={`action`}
                                   text={``}
                                   color={`primary`}
                                   currentPage={'dashboard/home'}
                                   action={()=> linkToEmbed(index, data[item].embed_uuid)}
                                   icon={`external-link-alt`}
                                   disabled={indexClicked !== null && indexClicked !== index}
                                   operation={`load`}
                                   processing={indexClicked === index} />;
        tableData.push(tempObj)
    });

    return tableData
};

export const detailChartData = (data) =>{
    //I added this check on the aggregate property to ensure that we arent showing a chart full of empty values
    //this is very specific to our current data structure but is the only way we can be sure
    if(!data || !data.total || !data.total.aggregate) return null;
    return transpileDetailedChartData(data);
};
//addons overview data doesnt use the aggregate property like all the others
//I created separate functions to avoid having complicated params in one function
export const revenueOverviewChartData = ( data ) => {
    if(!data || !data.total) return null;
    return transpileOverViewChartData(data);
}

export const contentOverviewChartData = ( data ) => {
    if(!data || !data.total || !data.total.aggregate) return null;
    return transpileOverViewChartData(data);
};
//-=-=-=-=-=-=-=-=-= helper methods -=-=-=-=-=-=-=-=//

const transpileDetailedChartData = (data) =>{
    let chartData = [];
    if(!Object.keys(data.total.by_date).length) return null;
    Object.keys(data).forEach(item=>{
        let tempDataArr = [];
        let tempObj = {};
        if(item !== 'total'){
            Object.keys(data[item].by_date).forEach(date => {

                tempDataArr.push({x: date, y: data[item].by_date[date]});
                tempDataArr.sort((a,b)=> new Date(a['x']).getTime() - new Date(b['x']).getTime());
                tempObj = {
                    id: item,
                    data: tempDataArr
                };
            });
            chartData.push(tempObj);
        }
    });
    return chartData;
};

const transpileOverViewChartData = (data) =>{
    let tempDataArr = [];
    //this if statement is here because rms and content metrics have slightly different data structures
    if(data.total.by_date){
        Object.keys(data.total.by_date).forEach(date=>{
            tempDataArr.push({x: date, y: data.total.by_date[date] === "null" ? null : Number(data.total.by_date[date])});
        });
    }else{
        Object.keys(data.by_date).forEach(date=>{
            tempDataArr.push({x: date, y: data.by_date[date] === "null" ? null : Number(data.by_date[date])});
        });
        //ensure data array is in order byDate
        tempDataArr.sort((a,b)=> new Date(a['x']).getTime() - new Date(b['x']).getTime());
    }


    return [{id: 'Total',
        color: "rgb(20, 148, 244)",
        data: tempDataArr}];
};

const formatDateRange = (datestring) => {
    const dayMonthYear = datestring.split('-');
    const dayMonthYearlen = dayMonthYear.length;

    if (dayMonthYearlen === 1) {
        return dayMonthYear.pop();
    } else {
        return dayMonthYearlen === 2 ?
            new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(new Date(datestring.replace(/-/g, '/') + '/01')) :
            new Intl.DateTimeFormat('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(datestring.replace(/-/g, '/')))
    }
}

export const transpileCommentingStatisticsData = (data) => {
    let tableData = [];
    if(!data) return tableData;
    Object.keys(data).forEach(item=>{
        if (item === 'hasMoreData') return;
        Object.keys(data[item]).forEach(date => {
            let tempObj = {};
            const formatDate = formatDateRange(date);
            const tempObjExists = tableData.find(({ dateRange }) => dateRange === formatDate);
            if (tempObjExists) {
                tempObjExists[item] = data[item][date];
            } else {
                tempObj.dateRange = formatDate;
                tempObj[item] = data[item][date];
                tableData.push(tempObj);
            }
        });
    });
    return tableData;
};
